<div style="background-color: #FFFFFF; border-radius: 4%; height: 85vh" class="shadow-lg">
  <!--HEADER-->
  <div class="nav-sections">
    <h4>Project Form</h4>
    <p class="bg-grey">Navigate sections below</p>
  </div>

  <!--FORM SECTIONS-->
  <div class="mb-3 nav-sections" id="form-accordion" style="overflow: auto; margin: 0 !important;">
    <div class="accordion">
      <div class="accordion-item" *ngFor="let section of sections; let i = index">
        <h2 class="accordion-header" [id]="'heading' + i">
          <button
            class="accordion-button"
            type="button"
            data-bs-toggle="collapse"
            [attr.data-bs-target]="'#collapse' + i"
            [attr.aria-expanded]="hasContent(section, i) ? 'true' : 'false'"
            [class.collapsed]="!hasContent(section, i)">
            {{ section.title }}
          </button>
        </h2>
        <div [id]="'collapse' + i"
             class="accordion-collapse collapse"
             [class.show]="hasContent(section, i)"
             [attr.aria-labelledby]="'heading' + i">
          <div class="accordion-body d-grid gap-2">
            <ng-container *ngFor="let btn of section.buttons">
              <button
                class="btn btn-section"
                [ngClass]="{'active': activeSteps.includes(sectionStepMap[btn])}"
                (click)="selectButton(btn)"
                *ngIf="shouldShow(btn)">
                {{ btn }}
              </button>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
